/**
 * Maps raw treatment history records into view models for the salon customer list.
 */

/**
 * Maps raw treatment history records into view models for the salon customer list.
 *
 * @typedef {Object} TreatmentHistory
 * @property {string[]} stylistNames
 * @property {string} sentAt
 * @property {boolean} hasPurchased
 * @property {number} salesAmount
 * @property {boolean} viewed
 * @property {boolean} favorited
 * @property {boolean} addedToCart
 * @property {boolean} purchased
 */
export default class TreatmentHistoryMapper {
  /**
   * Maps raw treatment history records into view models for the salon customer list.
   *
   * @param {TreatmentHistory} history
   * @returns {{
   *   stylistNames: string[],
   *   sentAt: Date,
   *   hasPurchased: boolean,
   *   salesAmount: number,
   *   viewed: boolean,
   *   favorited: boolean,
   *   addedToCart: boolean,
   *   purchased: boolean,
   * }} Treatment history view model
   */
  static toViewModel(history) {
    return {
      stylistNames: history.stylistNames,
      sentAt: new Date(history.sentAt),
      hasPurchased: history.hasPurchased,
      salesAmount: history.salesAmount,
      viewed: history.viewed,
      favorited: history.favorited,
      addedToCart: history.addedToCart,
      purchased: history.purchased,
    };
  }
}